/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundsEndTreatmentAliases {
  AUTOCOMPLETE_REASON_END = 'autocomplete-reason-end',
  FETCH_REASON_END_TREATMENT = 'fetch-reason-end-treatment',
  FIELD_REASON_END_TREATMENT = 'field-reason-end-treatment',
  FIELD_RELEASE_DATE = 'field-release-date',
  FORM_WOUNDS_END_TREATMENT = 'form-wounds-end-treatment',
  INPUT_RELEASE_DATE = 'input-release-date',
  LAYOUT_WOUNDS_END_TREATMENT = 'layout-wounds-end-treatment',
  MAPPER_REASON_END = 'mapper-reason-end',
  PANEL_WOUNDS_END_TREATMENT = 'panel-wounds-end-treatment',
  TEXT_REASON_END = 'text-reason-end',
}
export { WoundsEndTreatmentAliases };
